import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { NgoTypes, INgoState } from './types'
import { IActionType, success, failure, request} from '../root.types'
import { Ngo } from '../../application/models/ngo/ngo'

const INITIAL_STATE: INgoState = {
    create: {
        ngo: new Ngo(),
        loading: false,
        success: false,
        error: false
    }
}

// reducers para carregar os dados da NGO
export const loadNgoRequest = (state: INgoState = INITIAL_STATE) => {
    return { ...state, create: request({ ...state.create}) }
}

export const loadNgoSuccess = (
    state: INgoState = INITIAL_STATE,
    action: IActionType<{ data: Ngo, headers: any }>) => {
    const { data} = action.payload

    return {
        ...state,
        create: success({ ...state.create, ngo: data })
    }
}

export const loadNgoFailure = (state: INgoState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// reducers para atualizar dados do paciente 
export const updateNgoRequest = (state: INgoState = INITIAL_STATE, action: IActionType<{ ngo: Ngo }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const updateNgoSuccess = (state: INgoState = INITIAL_STATE,
    action: IActionType<{ data: Ngo }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, ngo: data }),
    }
}

export const updateNgoFailure = (state: INgoState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

// criar novo ngo
export const createNgoRequest = (state: INgoState = INITIAL_STATE, action: IActionType<{ ngo: Ngo }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const createNgoSuccess = (state: INgoState = INITIAL_STATE,
    action: IActionType<{ data: Ngo }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, ngo: data }),
    }
}

export const createNgoFailure = (state: INgoState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}

const reducer: Reducer<INgoState> = createReducer<INgoState>(INITIAL_STATE, {
   [NgoTypes.LOAD_NGO_REQUEST]: loadNgoRequest,
    [NgoTypes.LOAD_NGO_SUCCESS]: loadNgoSuccess,
    [NgoTypes.LOAD_NGO_FAILURE]: loadNgoFailure, 
    [NgoTypes.UPDATE_NGO_REQUEST]: updateNgoRequest,
    [NgoTypes.UPDATE_NGO_SUCCESS]: updateNgoSuccess,
    [NgoTypes.UPDATE_NGO_FAILURE]: updateNgoFailure,  
    [NgoTypes.CREATE_NGO_REQUEST]: createNgoRequest,
    [NgoTypes.CREATE_NGO_SUCCESS]: createNgoSuccess,
    [NgoTypes.CREATE_NGO_FAILURE]: createNgoFailure 
})
export default reducer    